// @flow

import { h } from 'preact';
import { connect } from 'unistore/full/preact';

import style from './App.css';

import PureComponent from './PureComponent';

import AppBar from '../components/AppBar';

import LoginPage from '../routes/home';
import StudentListPage from '../routes/students';
import SelectEventPage from '../routes/select';
import NewEventPage from '../routes/new';
import AdminOptionsPage from '../routes/admin';
import PrivacyPolicyPage from '../routes/privacy';
//import LoginPage from 'async!../routes/home';
//import StudentListPage from 'async!../routes/students';
//import SelectEventPage from 'async!../routes/select';
//import NewEventPage from 'async!../routes/new';
//import AdminOptionsPage from 'async!../routes/admin';
//import PrivacyPolicyPage from 'async!../routes/privacy';

import { Pages } from './appConstants';

import { Router, route } from 'preact-router';
import { Modes } from './appConstants';

const NotAuthorized = () => (
  <div className={style.textPadding}>This account is not authorized.</div>
);

@connect('accountMode')
class App extends PureComponent {
  handleRoute = e => {
    if (e.path !== Pages.Login) {
      switch (this.props.accountMode) {
        case Modes.Admin:
          break;
        case Modes.SectionLeader:
          if (e.path === Pages.Admin) {
            route(Pages.Login, true);
          }
          break;
        case Modes.SignedOut:
          route(Pages.Login, true);
          break;
        case Modes.Denied:
          route(Pages.Denied, true);
          break;
      }
    }
  };

  render() {
    return (
      <div className={style.app}>
        <AppBar />

        <Router onChange={this.handleRoute}>
          <LoginPage path={Pages.Login} />
          <SelectEventPage path={Pages.SelectEvent} />
          <NewEventPage path={Pages.NewEvent} />
          <StudentListPage path={Pages.StudentList} />
          <AdminOptionsPage path={Pages.Admin} />
          <NotAuthorized path={Pages.Denied} />
          <PrivacyPolicyPage path={Pages.PrivacyPolicy} />
        </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./components/App.js